import React from "react";
import { IconCheckedLight, skinVars } from "@telefonica/mistica";
import { observer } from "mobx-react-lite";
import { strings } from "../../../../localization";
import Feedback from "../../../../components/templates/Feedback";
import { useAnalytics, useNavigateCustom } from "../../../../hooks";

const ValidateDocumentsHome: React.FC = observer(() => {
	const navigate = useNavigateCustom();
	const { title, description } = strings.pages.validateDocumentsUnderApproved;
	const { buttonPrimary } = strings.components.buttons;
	const { addAnalyticEvent, updatePageView } = useAnalytics();

	const onAction = React.useCallback(() => {
		addAnalyticEvent({
			component: "button",
			action: "click.button",
			step: "fgts:cadastro:documentos-aprovados",
			event: "interaction",
			product: "fgts",
			description: buttonPrimary,
		}, {applySanitize: true});
		navigate("/withdraw-payment-info");
	}, []);

	React.useEffect(() => {
		updatePageView({
			name: "Vivo Money Cadastro FGTS Documentos Aprovados",
			pagePath: "/cadastro-fgts/documentos-aprovados",
		});
	}, []);


	return (
		<Feedback
			heroDataInfoProps={{
				icon: <IconCheckedLight size={64} color={skinVars.colors.success} />,
				title,
				description,
			}}
			buttonProps={{
				textButton: buttonPrimary,
				onAction,
			}}
		/>
	);
});

export default ValidateDocumentsHome;
